import React from 'react';
import styled from 'styled-components'
import { Icon } from '../../components/Icon'

interface Props {
	onChange: (value: string) => void
}

const Wrapper = styled.div`
	overflow: hidden;
`;

const InputWrapper = styled.div`
	margin-right: 3rem;
	input {
		margin: 0;
	}
`;

const IconWrapper = styled.div`
	float: right;
	text-align: right;
	width: 3rem;
`;

export const FilterInput: React.FC<Props> = (props: Props) => {
	return (
		<Wrapper>
			<IconWrapper>
				<Icon name="small--search" />
			</IconWrapper>
			<InputWrapper>
				<input placeholder={'Hae simmiä nimellä tai numerolla'} type="text" onChange={(e: React.ChangeEvent<HTMLInputElement>) => props.onChange(e.target.value)} />
			</InputWrapper>
		</Wrapper>
	);
};
